import React from 'react';
import { Modal, ModalFooter, Stack, Text, Link } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

const RateLimitFailureAlert = () => {
  const [state, dispatch] = useProductDetailsPageContext();

  const onClose = () => dispatch({ type: 'CLOSE_RATE_LIMIT_FAILURE_ALERT' });

  const modalHeading = (
    <Stack spacing={0} hAlign="center">
      You’ve already reached our daily order limit
    </Stack>
  );

  const modalFooter = (
    <Stack spacing={0} hAlign="center">
      <ModalFooter
        primaryAction={{
          text: 'Got it',
          onClick: onClose,
        }}
      />
    </Stack>
  );

  return (
    <Modal
      isOpen={state.showRateLimitFailureModal}
      onClose={onClose}
      heading={modalHeading}
      footer={modalFooter}
      variant="inset-small"
      size="medium"
      hAlign="center"
    >
      <Text setting="body-small" align="center" mt={1}>
        If you haven’t placed any previous orders today, please&nbsp;
        <Link
          size="tertiary"
          href="https://support.stitchfix.com/hc/en-us/requests/new"
          underline="initial"
        >
          contact us
        </Link>
        .
      </Text>
    </Modal>
  );
};

export default RateLimitFailureAlert;
